import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import Helper from "../util/helper";

export default function DigBarChart({ data, compareData, exerciseName1, exerciseName2 }) {

  // first pass with first data
  var formattedData = []
  data && data.map(d => {
    var tDay = {
      date: Helper.convertToDateString(d.Date),
      rawDate: d.Date,
      value: Math.round(d.MetricValue),
      compareValue: null
    }
    formattedData.push(tDay)
    return null
  })

  // next pass with compare data
  compareData && compareData.map(c => {
    const dateToFind = Helper.convertToDateString(c.Date)
    var foundDateItem = formattedData.find(d => d.date === dateToFind)
    if (foundDateItem) {
      foundDateItem.compareValue = Math.round(c.MetricValue)
    } else {
      var tDay = {
        date: Helper.convertToDateString(c.Date),
        rawDate: c.Date,
        value: null,
        compareValue: Math.round(c.MetricValue)
      }
      formattedData.push(tDay)    
    }
    return null
  })

  formattedData && formattedData.sort((a, b) => {
    const dateA = a.rawDate; // Convert names to uppercase for case-insensitive sorting
    const dateB = b.rawDate;
  
    if (dateA < dateB) {
      return -1;
    }
    if (dateA > dateB) {
      return 1;
    }
    return 0;
  });

  
  return (
    <ResponsiveContainer width="90%" height={300}>
      <BarChart
        data={formattedData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar name={exerciseName1} dataKey="value" fill="#8884d8" />
        <Bar name={exerciseName2} dataKey="compareValue" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
}
